export const earn = {
    jdzb: "Kolay Kazanç",
    jryd: "Finansın Yolu, Birlikte İlerlemek",
    jrbk: "Biking Kolay Kazanç'a katılın, yeniliklerle dijital varlıklarınızdan maksimum getiri elde edin",
    zbz: "Kazanç Devam Ediyor",
    ljsy: "Toplam Kazanç",
    zrsy: "Dünkü Kazanç",
    hq: "Vadesiz",
    dq: "Vadeli",
    cknh: "Referans Yıllık Getiri",
    sqjd: "Satın Alma Durumu",
    sg: "Satın Al",
    qbcp: "Tüm Ürünler",
    cz: "Sıfırla",
    qx: "Vade",
    question1: "1. Kazanç Nedir?",
    question1_text: "Kazanç, BIKING'in kullanıcılara çeşitli coin tutma ürün fırsatlarını keşfetmeleri için oluşturduğu tek duraklı hizmet platformudur. Şu anda Kolay Kazanç (istediğiniz zaman yatırıp çekebilirsiniz) sunulmaktadır, ileride daha fazla ürün eklenerek kullanıcılara zengin ürün seçeneği sağlanacaktır.",
    question2: "2. Referans Yıllık Getiri Nedir?",
    question2_text: "Kazanç geliri şu anda yatırılan token'ların faizidir. Referans yıllık getiri, yatırılan token'ların yıllık faiz oranıdır, örneğin bir üründe ilk 1000U %12 referans yıllık getiriye tabidir, ilk 1000U'yu aşan kısım %2 referans yıllık getiriye tabidir, toplam referans faiz yıllık getirisi %14'tür.",
    question3: "3. Faiz ne zaman başlar/hesaplanır?",
    question3_text: "Farklı ürünler satın alındığında, faizin başlama/hesaplama zamanı farklılık gösterebilir. Şu anki USDT günlük faizli Kolay Kazanç örneğinde, USDT vadesiz ürün satın alındıktan sonraki gün saat 02:00'da (UTC+8) faiz başlar, faiz ödemesi T+1 günü (yani satın alma zamanı T+2) saat 05:00'da (UTC+8) bir önceki günün faizi olarak dağıtılır;",
    question4: "4. Kalan Yatırım Limiti Nedir?",
    question4_text: "Kalan yatırım limiti, o finansman ürününden daha ne kadar satın alabileceğinizdir<br/>Kalan Yatırım Limiti = Toplam Ürün Satın Alma Limiti - Sizin zaten satın aldığınız miktar",
    xzmbfs: "Coin Yatırma/Satın Alma Yöntemini Seçin",
    nhsyl: "Yıllık Getiri Oranı ve Vade:",
    sl: "Miktar",
    qitou: "Minimum Yatırım",
    max: "Maksimum",
    kzcsl: "Bu, Fon Hesabından çıkarılabilecek miktardır",
    sykt: "Kalan Limiti",
    syktsl: "Kalan limit, daha satın alabileceğiniz miktardır",
    syktsx: "Kalan Limit = Toplam Ürün Satın Alma Limiti - Sizin satın aldığınız miktar (kişisel maksimum yatırım limiti {amount}{coin}'i aşamaz)",
    jlgz: "Ödül Kuralları",
    jd1: "Kademe 1: İlk {amount}{coin}",
    ptjl: "Platform Ödülü",
    jd2: "Kademe 2: İlk {amount}{coin}'den fazlası",
    jd22: "Kademe",
    jd3: "Kademe 3: {amount}{coin}'den fazlası",
    grsgsx: "Kişisel maksimum satın alma limiti {amount}{coin}'dir",
    gz: "Kural",
    sgsj: "Satın Alma Zamanı",
    xianzai: "Şimdi",
    qxsj: "Faiz Başlangıç Zamanı",
    lxrz: "Faiz Hesaba Geçti",
    c2c: "C2C Coin Al",
    lhxz: "Esnek seçim, daha iyi fiyat",
    lcjd: "Basit süreç, hızlı işlem",
    crszhb: "Cüzdanınızdan veya borsadan dijital para yatırın",
    zcsl: "Varlık Miktarı",
    dzsy: "Hesaba Geçen Kazanç",
    lcxx: "Finansman Bilgisi",
    zt: "Durum",
    sh: "Geri Çek",
    sgje: "Satın Alma Miktarı",
    sgzj: "Satın alma fonunun ilk {amount}{coin}'i {value}% ödüllü yıllık getiri kazandırır",
    dyklqje: "{amount}{coin}'den fazlası {value}% ödüllü yıllık getiri kazandırır",
    grsged: "Kişisel satın alma kotası {amount}～{amount2}{coin} arasındadır",
    shsl: "Geri Çekme Miktarı",
    srshsl: "Geri çekme miktarını girin",
    ksh: "Geri Çekilebilir:",
    haode: "Tamam",
    sgcg: "Satın Alma Başarılı",
    shcg: "Geri Çekme Başarılı",
    zcsg: "Tekrar Satın Al",
    sjdzsl: "Hesaba Geçen Gerçek Miktar",
    shsj: "Geri Çekme Zamanı",
    jssj: "Ödeme Zamanı",
    yjsdd: "Ödenmiş Siparişler",
    jyjl: "İşlem Geçmişi",
    hqjdzb: "Vadesiz Kolay Kazanç",
    sy: "Kazanç",
    wwc: "Tamamlanmadı",
    xmlx: "Proje Türü",
    hqjdzbcp: "Vadesiz Kolay Kazanç, Biking'in oluşturduğu güvenli bir finansman ürünüdür, 24 saat boyunca istenildiği zaman yatırılıp çekilmeyi destekler, saatlik faiz hesaplar",
    nh: "Yıllık",
    zhzchz: "Hesap varlık transferi, basit ve hızlı",
    qsrsl: "Lütfen miktarı girin",
    yjssymx: "Ödenmiş Kazanç Detayları",
    mx: "Detay",
    qwsmrz: "Kimlik Doğrulamaya Git",
    jxwcsmrz: "1. Bu etkinlik sadece kimliğini doğrulamış kullanıcılar içindir, her kullanıcının bu etkinliğe katılma hakkı yalnızca bir defadır",
    dqcked: "2. Her kullanıcının vadeli mevduat kotası {min}~{max}{coin}'dir, vade sonunda sistem otomatik olarak hesaba geri çeker",
    cpbntjsh: "3. Bu ürün vadeden önce geri çekilemez",
    anzh: "4. Ürün satın alma tamamlandığında, toplam havuz 0 olur, buton grileşir",
    smrzyh: "Etkinlik sadece kimliğini doğrulamış kullanıcılar içindir,",
    jxcjyc: "Uygun her kullanıcı yalnızca bir kez katılabilir",
    ygsy: "Tahmini Kazanç",
    scqx: "Bloke Süresi",
    qixian: "{min}. Gün (Toplam {max} Gün)",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/earn/tr.js